import React from 'react';

export const Html = ({ className, content }) => {
  if (!content) return null;
  const htmlWithBreaks = content.split('\n').join('<br>');
  return <div className={className} dangerouslySetInnerHTML={{ __html: htmlWithBreaks }} />;
};
